import React from 'react';
import { Flex } from 'rebass/styled-components';

import { layout } from '../constants/constants';
import useFeatureToggle from '../shared/hooks/use-feature-toggle/useFeatureToggle';
import { FeatureToggle, GlobalToolbarContent, IconPack } from '../shared/models/app-data-model';
import GlobalToolbarSection from './global-toolbar-section/global-toolbar-section';
import './global-toolbar.scss';

export type GlobalToolbarProps = {
  content: GlobalToolbarContent;
  featureToggles: FeatureToggle[];
  iconPack: IconPack[];
};

const GlobalToolbar: React.FC<GlobalToolbarProps> = ({ content, featureToggles, iconPack }: GlobalToolbarProps) => {
  const globalToolbarEnabled = useFeatureToggle('global-toolbar', featureToggles);

  return (
    <>
      {globalToolbarEnabled && content && (
        <Flex flexDirection="row" justifyContent="space-between" className="global-toolbar-container">
          <Flex className="inner-toolbar-container" width={layout.pageWidth} px={layout.toolbarPaddingX}>
            <GlobalToolbarSection
              content={content.toolbar_left_content}
              featureToggles={featureToggles}
              iconPack={iconPack}
              className="left-tools"
            />
            <GlobalToolbarSection
              content={content.toolbar_right_content}
              featureToggles={featureToggles}
              iconPack={iconPack}
              className="right-tools"
            />
          </Flex>
        </Flex>
      )}
    </>
  );
};

export default GlobalToolbar;
